import { Injectable } from '@angular/core';
import { NotificationsService } from '../../../shared/components/notifications/service/notifications.service';

@Injectable({
  providedIn: 'root'
})
export class MercadoPagoErrorsService {
  private errorMessages: { [key: string]: string } = {
    'cc_rejected_bad_filled_date': 'La fecha de vencimiento de la tarjeta es incorrecta',
    'cc_rejected_bad_filled_other': 'Los datos de la tarjeta son incorrectos',
    'cc_rejected_bad_filled_security_code': 'El código de seguridad es incorrecto',
    'cc_rejected_blacklist': 'No pudimos procesar tu pago',
    'cc_rejected_call_for_authorize': 'Debes autorizar el pago con tu banco',
    'cc_rejected_card_disabled': 'Llama a tu banco para activar tu tarjeta',
    'cc_rejected_card_error': 'No pudimos procesar tu pago',
    'cc_rejected_duplicated_payment': 'Ya realizaste un pago por este valor',
    'cc_rejected_high_risk': 'Tu pago fue rechazado',
    'cc_rejected_insufficient_amount': 'Tu tarjeta no tiene fondos suficientes',
    'cc_rejected_invalid_installments': 'Tu tarjeta no procesa pagos en estas cuotas',
    'cc_rejected_max_attempts': 'Llegaste al límite de intentos permitidos',
    'cc_rejected_other_reason': 'Tu tarjeta no procesó el pago',
    'cc_rejected_rejected': 'El pago fue rechazado',
  };

  constructor(private notificationsService: NotificationsService) {}

  handleError(errorCode: string, defaultMessage?: string): void {
    const message = this.errorMessages[errorCode] || defaultMessage || 'Error en el proceso de pago';
    this.notificationsService.addNotification({
      message,
      type: 'error',
      duration: 6000
    });
  }

  handleHttpError(error: any): void {
    if (error.status === 400) {
      this.notificationsService.addNotification({
        message: `Error de validación: ${error.error?.message || 'Datos inválidos'}`,
        type: 'error'
      });
    } else if (error.status === 401) {
      this.notificationsService.addNotification({
        message: 'Error de autenticación. Por favor, inicie sesión nuevamente.',
        type: 'error'
      });
    } else if (error.code) {
      this.handleError(error.code);
    } else {
      this.notificationsService.addNotification({
        message: error.message || 'Error desconocido en el proceso de pago',
        type: 'error'
      });
    }
  }
}
